// Full size
const ThePhantomMenace = require('../../assets/images/films/posters/the-phantom-menace.png');
const RevengeOfTheSith = require('../../assets/images/films/posters/revenge-of-the-sith.png');
const AttackOfTheClones = require('../../assets/images/films/posters/attack-of-the-clones.png');
const ANewHope = require('../../assets/images/films/posters/a-new-hope.png');
const TheEmpireStrikesBack = require('../../assets/images/films/posters/the-empire-strikes-back.png');
const ReturnOfTheJedi = require('../../assets/images/films/posters/return-of-the-jedi.png');
const TheForceAwakens = require('../../assets/images/films/posters/the-force-awakens.png');

// Thumbnails
const ThePhantomMenaceThumbnail = require('../../assets/images/films/posters/thumbnails/the-phantom-menace-thumb.png');
const RevengeOfTheSithThumbnail = require('../../assets/images/films/posters/thumbnails/revenge-of-the-sith-thumb.png');
const AttackOfTheClonesThumbnail = require('../../assets/images/films/posters/thumbnails/attack-of-the-clones-thumb.png');
const ANewHopeThumbnail = require('../../assets/images/films/posters/thumbnails/a-new-hope-thumb.png');
const TheEmpireStrikesBackThumbnail = require('../../assets/images/films/posters/thumbnails/the-empire-strikes-back-thumb.png');
const ReturnOfTheJediThumbnail = require('../../assets/images/films/posters/thumbnails/return-of-the-jedi-thumb.png');
const TheForceAwakensThumbnail = require('../../assets/images/films/posters/thumbnails/the-force-awakens-thumb.png');

module.exports = {
  ThePhantomMenace,
  AttackOfTheClones,
  RevengeOfTheSith,
  ANewHope,
  TheEmpireStrikesBack,
  ReturnOfTheJedi,
  TheForceAwakens,
  thumbnails: {
    ThePhantomMenace: ThePhantomMenaceThumbnail,
    AttackOfTheClones: AttackOfTheClonesThumbnail,
    RevengeOfTheSith: RevengeOfTheSithThumbnail,
    ANewHope: ANewHopeThumbnail,
    TheEmpireStrikesBack: TheEmpireStrikesBackThumbnail,
    ReturnOfTheJedi: ReturnOfTheJediThumbnail,
    TheForceAwakens: TheForceAwakensThumbnail,
  },
};
